module.exports = __webpack_public_path__ + "img/parliament-4.d62a2c1b.webp";